import { render } from "./ResetPasswordRequestSentView.vue?vue&type=template&id=2be2ffbc"
import script from "./ResetPasswordRequestSentView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordRequestSentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__